module.exports = __webpack_public_path__ + "img/ico_youtube_new.f1eac79c.svg";